import { IconProps } from '@repo/core/global-data/dataInterface.data';

export default function FileDownloadIcon({ width = '20', height = '21', className = '' }: IconProps) {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5 9.5V14.5L9.16667 12.8333"
                    stroke="#437DB3"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.49992 14.4987L5.83325 12.832"
                    stroke="#437DB3"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.3334 8.66667V12.8333C18.3334 17 16.6667 18.6667 12.5001 18.6667H7.50008C3.33341 18.6667 1.66675 17 1.66675 12.8333V7.83333C1.66675 3.66667 3.33341 2 7.50008 2H11.6667"
                    stroke="#437DB3"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.3334 8.66667H15.0001C12.5001 8.66667 11.6667 7.83333 11.6667 5.33333V2L18.3334 8.66667Z"
                    stroke="#437DB3"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
}
